
function $parcel$defineInteropFlag(a) {
  Object.defineProperty(a, '__esModule', {value: true, configurable: true});
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("3Pvlz", function(module, exports) {

$parcel$defineInteropFlag(module.exports);

$parcel$export(module.exports, "default", () => $36ae6fed7c630b17$export$2e2bcd8739ae039);
/* prettier-ignore */ /**
 * NOTE:
 *
 * This file is automatically generated by Traduki 2.0.
 * DO NOT CHANGE IT BY HAND or your changes will be lost.
 */ //Slovak
var $36ae6fed7c630b17$export$2e2bcd8739ae039 = {
    'ai-floating-context-menu.ai-dynamic-surface.rovo-panel-title': 'Rovo',
    'ai-smart-button.ai-actions.actions.section.text': 'Akcie',
    'ai-smart-button.ai-actions.give-feedback-action.title': "Poskytn\xfa\u0165 sp\xe4tn\xfa v\xe4zbu",
    'ai-smart-button.ai-actions.help.section.text': "Pomocn\xedk",
    'ai-smart-button.ai-actions.input.link-picker-button-label': 'Prepojenie',
    'ai-smart-button.ai-actions.input.mention-button-label': 'Spomenutie',
    'ai-smart-button.ai-actions.input.send-button-label': "Odosla\u0165",
    'ai-smart-button.ai-actions.item.betaLozenge': 'BETA',
    'ai-smart-button.ai-actions.item.newLozenge': "NOV\xc9",
    'ai-smart-button.ai-actions.rovo-agents.automation-icon-label': "Ikona automatiz\xe1cie",
    'ai-smart-button.ai-actions.rovo-agents.create-automation.text': "Vytvori\u0165 automatiz\xe1ciu",
    'ai-smart-button.ai-actions.rovo-agents.section.text': 'Studio',
    'ai-smart-button.ai-dynamic-surface.components.greeting.intro-text-headline': "Dobr\xfd de\u0148, {name},",
    'ai-smart-button.ai-proactive-nudge.dismiss': "Zru\u0161i\u0165",
    'ai-smart-button.feedback-action.ask-question-option': "Polo\u017Ei\u0165 ot\xe1zku",
    'ai-smart-button.feedback-action.cancel-button-label': "Zru\u0161i\u0165",
    'ai-smart-button.feedback-action.choose-feedback-option': "Vyberte mo\u017Enos\u0165",
    'ai-smart-button.feedback-action.feedback-entry-bug-heading': "Op\xedsa\u0165 chybu alebo probl\xe9m",
    'ai-smart-button.feedback-action.feedback-entry-comment-heading': "Let us know what's on your mind",
    'ai-smart-button.feedback-action.feedback-entry-question-heading': "\u010Co by ste chceli vedie\u0165?",
    'ai-smart-button.feedback-action.feedback-entry-suggest-heading': "Dajte n\xe1m vedie\u0165, \u010Do by ste chceli zlep\u0161i\u0165",
    'ai-smart-button.feedback-action.feedback-modal-heading': "Pode\u013Ete sa o svoje my\u0161lienky",
    'ai-smart-button.feedback-action.leave-comment-option': "Zanechajte koment\xe1r",
    'ai-smart-button.feedback-action.report-bug-option': "Nahl\xe1si\u0165 chybu",
    'ai-smart-button.feedback-action.research-participation-message': "Chcem sa z\xfa\u010Dastni\u0165 produktov\xe9ho prieskumu",
    'ai-smart-button.feedback-action.select-feedback-heading': "Vyberte sp\xe4tn\xfa v\xe4zbu",
    'ai-smart-button.feedback-action.submit-button-label': "Odosla\u0165 sp\xe4tn\xfa v\xe4zbu",
    'ai-smart-button.feedback-action.suggest-improvement-option': "Navrhn\xfa\u0165 zlep\u0161enie",
    'ai-smart-button.feedback-action.title': "Poskytn\xfa\u0165 sp\xe4tn\xfa v\xe4zbu",
    'ai-smart-button.reference.close-button-label': "Zatvori\u0165"
};

});


//# sourceMappingURL=sk.e32562c4.js.map
